import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { IbDirectivesModule } from '../ib-directives/ib-directives.module';

import { AppVersionComponent } from './app-version.component';

@NgModule({
	imports: [
		CommonModule,
		IbDirectivesModule,
	],
	declarations: [AppVersionComponent],
	exports: [AppVersionComponent],
})
export class AppVersionModule { }
